import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
import {
  DeleteDocumentSetDTO,
  DetailDocumentSetDTO,
  DocumentSetDTO,
  GetAllListDocumentSetDTO,
  GetListDocumentSetDTO,
  HttpService,
  ResponseDTO,
  UpdateDocumentSetDTO,
} from '@/shared';
import {IResponseTemplateSet} from '@/types';

@Service()
export class DocumentSetService {
  @observable
  private httpService = Container.get(HttpService);

  @action.bound
  public async createDocumentSet(
    documentSetDTO: DocumentSetDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(documentSetDTO);
  }
  public async getListDocumentSet(
    getListDocumentSetDTO: GetListDocumentSetDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getListDocumentSetDTO);
  }
  public async getAllListDocumentSet(
    getListDocumentSetDTO: GetAllListDocumentSetDTO,
  ): Promise<ResponseDTO<IResponseTemplateSet>> {
    return this.httpService.request(getListDocumentSetDTO);
  }
  public async deleteDocumentSet(
    deleteTemplateDTO: DeleteDocumentSetDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(deleteTemplateDTO);
  }
  public async getDetailDocumentSet(
    getListDocumentSetDTO: DetailDocumentSetDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(getListDocumentSetDTO);
  }
  public async updateDocumentSet(
    updateTemplateDTO: UpdateDocumentSetDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(updateTemplateDTO);
  }
}
